export const CLIENT_SESSION_STATUS = {
  LOADING: 'loading',
  READY: 'ready',
} as const;
